import { request } from "../helper/axios_helper";

export const createTask = (
  taskName,
  taskCategory,
  taskSubCategory,
  testSuiteId,
  comments,
  dateTime,
  testSuiteIdTwo,
) => {
  return request("POST", "/api/auth/task/create", {
    taskName: taskName,
    taskCategory: taskCategory,
    taskSubCategory: taskSubCategory,
    testSuiteId: testSuiteId,
    comments: comments,
    createdDate: dateTime,
    updatedDate: dateTime,
    testSuiteIdTwo: testSuiteIdTwo,
  });
};

export const getAllTasks = () => {
  return request("GET", "/api/auth/task/fetch/all");
};

export const createTaskRelationship = (
  subCategory,
  taskId,
  mappingName,
  matchType,
  fileName,
  matchTypeTwo,
  fileNameTwo,
  delimiter,
  delimiterTwo,
) => {
  return request("POST", "/api/auth/task/create/relationship", {
    taskId: taskId,
    mappingName: mappingName,
    subCategory: subCategory,
    matchType: matchType,
    fileName: fileName,
    matchTypeTwo: matchTypeTwo,
    fileNameTwo: fileNameTwo,
    delimiter: delimiter,
    delimiterTwo: delimiterTwo,
  });
};

export const createTaskRelationshipProcess = (
  taskId,
  matchType,
  fileName,
  sql,
  envName,
  dbName,
  eventType,
) => {
  return request("POST", "/api/auth/task/create/relationship/process", {
    taskId: taskId,
    matchType: matchType,
    fileName: fileName,
    sql: sql,
    envName: envName,
    dbName: dbName,
    eventType: eventType,
  });
};

export const getTaskByIdAndType = (taskId, category) => {
  return request("GET", `/api/auth/task/fetch/task/${taskId}/${category}`);
};
